import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SIcon } from '@avalara/skylab-sdk/react';

type InfoPanelProps = {
  headingText: string;
  content: Array<string>;
};

const InformationPanel = ({ headingText, content }: InfoPanelProps) => (
  <SCol span='6'>
    <h2 data-ref='buy.returns-thankyou.info-panel.header' className='pad-top-lg pad-bottom-sm text-center'>
      {headingText}
    </h2>
    {content.map((bulletText, i) => (
      <p
        key={bulletText}
        data-ref={`buy.returns.thankyou.info-panel.content-${i}`}
        className='pad-all-xs text-left'
        style={{ width: '100%' }}
      >
        {content.length > 1 && (
          <SIcon
            name='check'
            className='pad-right-xs'
            aria-label={t('client.accessibility.check-mark-for-bulleted-text')}
          />
        )}
        {bulletText}
      </p>
    ))}
  </SCol>
);
export default InformationPanel;
